import type {AttributePermissionIndexed} from '../types';
import {ACTIONS} from './constants';
import type {Action} from './actions';
import equal from 'fast-deep-equal';

export type State = {
	data: AttributePermissionIndexed[];
	originalData: AttributePermissionIndexed[];
	loading: boolean;
	ready: boolean;
	saving: boolean;
	templateId?: number;
	unsavedChanges: boolean;
};

export const initialState: State = {
	data: [],
	originalData: [],
	loading: false,
	ready: false,
	saving: false,
	unsavedChanges: false,
};

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case ACTIONS.RESET:
			return {
				...state,
				data: state.originalData,
				unsavedChanges: false,
			};

		case ACTIONS.UPDATE:
			return {
				...state,
				data: action.data,
				originalData: action.data,
				unsavedChanges: false,
				ready: true,
			};

		case ACTIONS.SET_LOADING:
			return {
				...state,
				loading: action.loading,
			};

		case ACTIONS.SET_SAVING:
			return {
				...state,
				saving: action.saving,
			};

		case ACTIONS.SET_TEMPLATE_ID:
			if (state.templateId === action.templateId) return state;
			return {
				...state,
				data: [],
				originalData: [],
				templateId: action.templateId,
				ready: false,
			};

		case ACTIONS.ADD_PERMISSION: {
			if (!state.templateId) return state;

			const data = state.data.filter(
				(d) => d.groupId !== action.permission.groupId,
			);
			data.push({
				templateId: state.templateId,
				id: state.templateId,
				read: false,
				write: false,
				index: data.length,
				...action.permission,
			});
			return {
				...state,
				data,
				unsavedChanges: !equal(
					data.filter((d) => d.read || d.write),
					state.originalData,
				),
			};
		}

		case ACTIONS.DELETE_PERMISSION: {
			const data = state.data.filter((d) => d.groupId !== action.groupId);
			return {
				...state,
				data,
				unsavedChanges: !equal(
					data.filter((d) => d.read || d.write),
					state.originalData,
				),
			};
		}

		case ACTIONS.UPDATE_PERMISSION: {
			const data = JSON.parse(
				JSON.stringify(state.data),
			) as AttributePermissionIndexed[];
			const existingRecord = data.find(
				(data) => data.groupId === action.permission.groupId,
			);

			if (action.permission.write) action.permission.read = true;

			!existingRecord
				? data.unshift({...action.permission, index: 0})
				: Object.assign(existingRecord, action.permission);

			return {
				...state,
				data: data.map((d, index) => ({...d, index})),
				unsavedChanges: !equal(
					data.filter((d) => d.read || d.write),
					state.originalData,
				),
			};
		}
	}
};

export default reducer;
